import axios from 'axios'
const ServiceURL = process.env.VUE_APP_SERVICEURL
// const pandapaKita = process.env.VUE_APP_PANDAPAKITA

export default {
    name: 'notification',
    state: {
        notification: {
            aksi: [],
            informasi: []
        },
    },
    getters: {
        getNotification: state => {
            return state.notification
        },
    },
    mutations: {
        NOTIFICATION: (state, payload) => {
            if (payload[0] !== undefined) {
                state.notification.aksi = payload[0].data.data;
            } else {
                state.notification.aksi = [];
            }
            if (payload[1] !== undefined) {
                state.notification.informasi = payload[1].data.data;
            } else {
                state.notification.informasi = [];
            }
        },
    },
    actions: {
        async FETCH_NOTIFICATION(store) {
            const aksi = axios({
                method: "get",
                url: ServiceURL + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.auth.auth.username,
                    aksi: 2
                },
                auth: {
                    username: store.rootState.auth.auth.username,
                    password: store.rootState.auth.auth.password,
                },
                headers: {
                    "X-API-KEY": store.rootState.auth.auth.apikey
                }
            }).catch(err => {
                console.log(err);
            });

            const informasi = axios({
                method: "get",
                url: ServiceURL + "notifikasi/aksi",
                params: {
                    tlc: store.rootState.auth.auth.username,
                    aksi: 1
                },
                auth: {
                    username: store.rootState.auth.auth.username,
                    password: store.rootState.auth.auth.password
                },
                headers: {
                    "X-API-KEY": store.rootState.auth.auth.apikey
                }
            }).catch(err => {
                console.log(err);
            });

            return await axios
                .all([
                    aksi.catch(err => {
                        return console.log(err);
                    }),
                    informasi.catch(err => {
                        return console.log(err);
                    })
                ])
                .then(response => {
                    store.commit('NOTIFICATION', response)
                });
        }
    }
}
